import { createSlice } from '@reduxjs/toolkit'

const initialValue = {
    unapproved_users:[],
    unverified_users:[],
    all_users: [],
    is_loading:false,
    resend_link_loading:false,
    user_action_loading:false
}


export const userManagementSlice = createSlice({
    name: 'user',
    initialState: initialValue,
    reducers: {
        setUserState: (state, action) => {
            assignValueInState(action.payload, state)
        },
        resetUserState: (state) => {
            assignValueInState(initialValue, state)
        },
    },
})

const assignValueInState = (obj, state) => {
    for (const key in obj) { state[key] = obj[key] }
}

export const { setUserState, resetUserState} = userManagementSlice.actions
export default userManagementSlice.reducer